import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
    extends: Line,
    mixins: [reactiveProp],
    props: ['options'],
    computed: {
        labels() {
            return this.chartData.labels
        },
    },
    mounted() {
        // this.chartData is created in the mixin.
        // If you want to pass options please create a local options object
        this.renderChart(this.chartData, this.options)
    },
    watch: {
        labels() {
            this._data._chart.destroy()
            this.renderChart(this.chartData, {
                responsive: true,
                elements: {
                    line: {
                        tension: 0,
                    },
                },
                legend: {
                    position: 'top',
                    align: 'start',
                },
                scales: {
                    xAxes: [
                        {
                            ticks: {
                                callback: function (str) {
                                    var maxwidth = 30
                                    var sections = []
                                    var words = str.split(' ')
                                    var temp = ''

                                    words.forEach(function (item, index) {
                                        if (temp.length > 0) {
                                            var concat = temp + ' ' + item

                                            if (concat.length > maxwidth) {
                                                sections.push(temp)
                                                temp = ''
                                            } else {
                                                if (index == words.length - 1) {
                                                    sections.push(concat)
                                                    return
                                                } else {
                                                    temp = concat
                                                    return
                                                }
                                            }
                                        }

                                        if (index == words.length - 1) {
                                            sections.push(item)
                                            return
                                        }

                                        if (item.length < maxwidth) {
                                            temp = item
                                        } else {
                                            sections.push(item)
                                        }
                                    })

                                    return sections
                                },
                                padding: 10,
                            },
                            gridLines: {
                                color: 'rgba(0, 0, 0, 0)',
                            },
                        },
                    ],
                },
            })
        },
    },
}
